export const FIND_LANGUAGES_FAILURE = 'FIND_LANGUAGES_FAILURE';

export const findLanguagesFailure = ( payload: Error ) => ({
    type: FIND_LANGUAGES_FAILURE,
    payload,
});